export var TICKET_VOUCHER = 'voucher';
export var TICKET_COUPON = 'coupon';